"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var delete_1 = __importDefault(require("material-ui/svg-icons/action/delete"));
var styles_1 = __importDefault(require("./styles"));
var constants_1 = require("./constants");
var Loader_1 = __importDefault(require("./Loader"));
var Footer_1 = __importDefault(require("./Footer"));
var Caption_1 = __importDefault(require("./Caption"));
var Header_1 = __importDefault(require("./Header"));
var Body_1 = __importDefault(require("./Body"));
var index_1 = require("../../../utils/index");
var tokenApi_1 = require("../../../api/tokenApi");
var Grid = function (_a) {
    var styles = _a.styles, rest = __rest(_a, ["styles"]);
    return (react_1.default.createElement("div", { className: "uas-grid", style: styles.gridWrapper },
        react_1.default.createElement("table", { style: styles.grid },
            rest.loading && react_1.default.createElement(Loader_1.default, null),
            react_1.default.createElement(Caption_1.default, __assign({}, rest)),
            react_1.default.createElement(Header_1.default, __assign({}, rest)),
            react_1.default.createElement(Footer_1.default, __assign({}, rest)),
            react_1.default.createElement(Body_1.default, __assign({}, rest)))));
};
var headerOverStyle = {
    opacity: '.6',
};
var rowStyleFn = function (item) {
    return item && item.deleted ? { backgroundColor: '#848484' } : undefined;
};
var itemComparator = function (itemA, itemB) {
    var idA = lodash_1.get(itemA, 'id');
    var idB = lodash_1.get(itemB, 'id');
    return idA && idB ? idA === idB : itemA === itemB;
};
exports.default = recompose_1.compose(recompose_1.pure, muiThemeable_1.default(), recompose_1.withProps(function (_a) {
    var muiTheme = _a.muiTheme, style = _a.style;
    return ({ styles: styles_1.default(muiTheme, style) });
}), recompose_1.withContext({ styles: prop_types_1.default.object }, function (_a) {
    var styles = _a.styles;
    return ({ styles: styles });
}), recompose_1.defaultProps({
    pageSizeItems: [
        { id: 10, label: '10' },
        { id: 20, label: '20' },
        { id: 50, label: '50' },
        { id: 100, label: '100' },
        { id: 1000, label: '1000' },
    ],
    locale: 'cs',
    sort: null,
    columnManager: false,
    headerOverStyle: headerOverStyle,
    draggable: true,
    order: constants_1.Order.DESC,
    pageSize: 10,
    page: 0,
    columns: [],
    items: [],
    filters: [],
    count: 0,
    setPageSize: lodash_1.noop,
    onMaxCountReached: lodash_1.noop,
    setSort: lodash_1.noop,
    setOrder: lodash_1.noop,
    groupRowFormat: lodash_1.noop,
    onRemoveAllFilters: lodash_1.noop,
    showHeadPager: false,
    showFootPager: true,
    showPagerInput: true,
    filterRow: false,
    adding: true,
    editing: true,
    deleting: false,
    filtering: true,
    openFiltersOnFilterRowChange: false,
    changeFilterValueOnEnter: false,
    enableUniversalFilter: false,
    enableUniversalFilterClear: false,
    changeUniversalFilterValueOnEnter: false,
    resetSettingsOnRemoveAllFilters: true,
    enableAggregation: true,
    sorting: true,
    grouping: false,
    paging: true,
    checkboxChange: lodash_1.noop,
    checkAllItems: lodash_1.noop,
    showCheckboxes: false,
    enableMultipleCheck: false,
    addItem: lodash_1.noop,
    editItem: lodash_1.noop,
    deleteItems: lodash_1.noop,
    restoreItems: lodash_1.noop,
    deactivateItem: lodash_1.noop,
    activateItem: lodash_1.noop,
    itemComparator: itemComparator,
    allowRestore: function () { return tokenApi_1.hasPermission('ROLE_DELETED'); },
    showDeleted: function () { return tokenApi_1.hasPermission('ROLE_DELETED'); },
    showDeactivated: false,
    rowFunction: index_1.identity,
    reportLocation: null,
    rowStyleFn: rowStyleFn,
    deleteFiltersIcon: react_1.default.createElement(delete_1.default, null),
    filterRowDateFromPlaceholder: '',
    filterRowDateToPlaceholder: '',
}), recompose_1.branch(function (_a) {
    var locale = _a.locale;
    return locale === 'en';
}, recompose_1.defaultProps({
    numberOfEntriesLabel: 'Entries per page',
    numberDividerLabel: '/',
    addLabel: 'New',
    operationLabel: 'Operation',
    valueLabel: 'Value',
    filtersLabel: 'Filters',
    columnLabel: 'Column',
    deleteLabel: 'Delete',
    showDeactivatedLabel: 'Show deactivated',
    activateLabel: 'Activate',
    deactivateLabel: 'Deactivate',
    restoreLabel: 'Restore',
    columnsLabel: 'Columns',
    showDeletedLabel: 'Show deleted',
    cancelLabel: 'Cancel',
    closeLabel: 'Close',
    resetLabel: 'Reset columns',
    hideAllLabel: 'Hide all columns',
    exportLabel: 'Export',
    deleteFiltersTooltip: 'Delete filters',
    booleanTranslation: constants_1.TrueFalseEn,
    filterTranslations: constants_1.filterTranslationsEn,
}), recompose_1.defaultProps({
    numberOfEntriesLabel: 'Záznamů na stránku:',
    numberDividerLabel: 'z',
    addLabel: 'Přidat',
    operationLabel: 'Operace',
    valueLabel: 'Hodnota',
    filtersLabel: 'Filtry',
    columnLabel: 'Sloupec',
    deleteLabel: 'Smazat',
    showDeactivatedLabel: 'Zobrazit neaktivní',
    activateLabel: 'Aktivovat',
    deactivateLabel: 'Zneplatnit',
    restoreLabel: 'Obnovit',
    columnsLabel: 'Sloupce',
    showDeletedLabel: 'Zobrazit smazané',
    cancelLabel: 'Zrušit',
    closeLabel: 'Zavřít',
    resetLabel: 'Resetovat sloupce',
    hideAllLabel: 'Schovat všechny sloupce',
    exportLabel: 'Export',
    deleteFiltersTooltip: 'Smazat filtry',
    booleanTranslation: constants_1.TrueFalse,
    filterTranslations: constants_1.filterTranslations,
})), recompose_1.mapProps(function (_a) {
    var adding = _a.adding, deleting = _a.deleting, allowRestore = _a.allowRestore, showDeleted = _a.showDeleted, showDeactivated = _a.showDeactivated, rest = __rest(_a, ["adding", "deleting", "allowRestore", "showDeleted", "showDeactivated"]);
    return (__assign({}, rest, { adding: adding instanceof Function ? adding() : adding, deleting: deleting instanceof Function ? deleting() : deleting, allowRestore: allowRestore instanceof Function ? allowRestore() : deleting, showDeleted: showDeleted instanceof Function ? showDeleted() : deleting, showDeactivated: showDeactivated instanceof Function ? showDeactivated() : showDeactivated }));
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.count < this.props.count) {
            nextProps.setPage(0);
        }
    },
}))(Grid);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/index.js
// module id = 906
// module chunks = 0